export default {
  path: 'baremetal',
  name: 'baremetal',
  component: () => import('@/views/dashboard/baremetal/servers.vue'),
};
